export class DefaultOptions {
  constructor() {
    this.fileName = "relevantArticles";
    this.fileType = {
      driver: "endnotexml",
      extention: ".xml"
    };
  }
}

export const fileTypeOptions = [
  {
    value: { driver: "endnotexml", extention: ".xml" },
    text: "EndNote XML file"
  },
  {
    value: { driver: "csv", extention: ".csv" },
    text: "Comma Seperated Values"
  },
  {
    value: { driver: "json", extention: ".json" },
    text: "JSON file"
  },
  {
    value: { driver: "medline", extention: ".nbib" },
    text: "MEDLINE / PubMed file"
  },
  {
    value: { driver: "ris", extention: ".ris" },
    text: "RIS file"
  },
  {
    value: { driver: "tsv", extention: ".tsv" },
    text: "Tab Seperated Values"
  }
];

export const Ref = {
  recNumber: undefined,
  type: undefined,
  title: undefined,
  year: undefined,
  journal: undefined,
  authors: [],
  date: undefined,
  urls: [],
  pages: undefined,
  volume: undefined,
  number: undefined,
  isbn: undefined,
  abstract: undefined,
  label: undefined,
  caption: undefined,
  notes: undefined,
  address: undefined,
  researchNotes: undefined,
  keywords: [],
  accessDate: undefined,
  accession: undefined,
  doi: undefined,
  section: undefined,
  language: undefined,
  databaseProvider: undefined,
  database: undefined,
  workType: undefined,
  custom1: undefined,
  custom2: undefined,
  custom3: undefined,
  custom4: undefined,
  custom5: undefined,
  custom6: undefined,
  custom7: undefined,
  hash: undefined,
  conflict: undefined,
  pmid: undefined,
};